const tablist = [
    {
        selector: '[role=tablist]:not([data-react=buy-now-wizard] [role=tablist])',
        path: { filename: 'tablist' },
    },
];

export { tablist };
